import { HtmlDocType } from "./htmlDocType";

export class CreateOrUpdateStaticHtmlDocumentRequest {

  constructor(
    private documentType: HtmlDocType, 
    private htmlContent: string
  ) {}

  getDocumentType(): HtmlDocType { return this.documentType; }
  getHtmlContent(): string { return this.htmlContent; }

  static fromJson(json: any): CreateOrUpdateStaticHtmlDocumentRequest {
    return new CreateOrUpdateStaticHtmlDocumentRequest(json.documentType, json.htmlContent);
  }
}